export default {
  API_URL: 'https://enfinium-api.cometrootapp.com/api/',
  SANDBOX_URL: 'https://enfiniumsandbox-api.cometrootapp.com/api/'
  // API_URL: 'https://localhost:44365/api',
  // SANDBOX_URL: 'https://localhost:44365/api'
}
